import { render, staticRenderFns } from "./OptimizationSettings.vue?vue&type=template&id=67d1aacf&scoped=true&"
import script from "./OptimizationSettings.vue?vue&type=script&lang=ts&"
export * from "./OptimizationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1aacf",
  null
  
)

export default component.exports